import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonOrderedList
  from 'components/atoms/Editors/EditorMenuButtonOrderedList/EditorMenuButtonOrderedList.styles';

const EditorMenuButtonOrderedList = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonOrderedList');

  return <StyledEditorMenuButtonOrderedList buttonRef={ref} {...innerProps} />
});

EditorMenuButtonOrderedList.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonOrderedList;
